import { useState, useCallback, useMemo } from 'react'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { generateRecognizedMediaStrategy } from 'utils/insightModal/strategy/searchFilterComposing'
import { SocialWebPhotoConceptsWidget } from 'schemas/SocialWebPhotoConceptsWidgetSchema'
import { convertToInsightContentSetting, addSelectionFilterToWidgetSetting } from '../utils'
import useWidgetSettingComposingStrategy from './useWidgetSettingComposingStrategy'

const useSelectedInsights = (widgetSetting: SocialWebPhotoConceptsWidget) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedInsights, setSelectedInsights] = useState<InsightData[]>([])

  const searchFilterComposingStrategy = generateRecognizedMediaStrategy()
  const widgetSettingComposingStrategy = useWidgetSettingComposingStrategy(
    widgetSetting.viewOption!
  )

  const detailSetting = useMemo(
    () =>
      convertToInsightContentSetting(widgetSetting, searchFilterComposingStrategy, {
        insights: selectedInsights
      }),
    [searchFilterComposingStrategy, widgetSetting, selectedInsights]
  )

  const widgetSettingWithSelection = useMemo(
    () =>
      addSelectionFilterToWidgetSetting(widgetSetting, widgetSettingComposingStrategy, {
        insights: selectedInsights
      }),
    [widgetSettingComposingStrategy, widgetSetting, selectedInsights]
  )

  const onClick = useCallback(
    (insightData: InsightData) => {
      setIsModalOpen(true)
      setSelectedInsights([insightData])
    },
    [setIsModalOpen, setSelectedInsights]
  )

  const onClose = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return {
    isModalOpen,
    selectedInsights,
    onClick,
    onClose,
    detailSetting,
    widgetSettingWithSelection
  }
}

export default useSelectedInsights
